module.exports = __webpack_public_path__ + "static/media/qrcode.23b1e04c.svg";